var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "rgba(164,161,251,0.1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17770",
    "data-name": "Group 17770",
    transform: "translate(15.162 15.162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7420",
    "data-name": "Rectangle 7420",
    width: 60,
    height: 60,
    transform: "translate(-0.162 -0.162)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    d: "M76.341,55.6,65.4,50.928a3.641,3.641,0,0,0-3.524.3l-5.858,3.9A17.853,17.853,0,0,1,47.8,46.961h0l3.874-5.928A3.711,3.711,0,0,0,52,37.509L47.309,26.564a3.8,3.8,0,0,0-3.9-2.24A13.116,13.116,0,0,0,32,37.3,33.645,33.645,0,0,0,65.606,70.905,13.116,13.116,0,0,0,78.582,59.493a3.8,3.8,0,0,0-2.24-3.9Z",
    transform: "translate(-24.566 -18.663)",
    fill: "#a4a1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M152.311,35.523A16.943,16.943,0,0,1,164.189,47.4a1.867,1.867,0,0,0,1.8,1.4,1.774,1.774,0,0,0,.49-.07,1.844,1.844,0,0,0,1.307-2.287,20.537,20.537,0,0,0-14.516-14.516,1.867,1.867,0,1,0-.957,3.594Z",
    transform: "translate(-115.612 -24.425)",
    fill: "#a4a1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M144.011,66.423a9.428,9.428,0,0,1,6.6,6.6,1.844,1.844,0,0,0,1.8,1.4,1.493,1.493,0,0,0,.467-.07,1.844,1.844,0,0,0,1.33-2.287,13.022,13.022,0,0,0-9.242-9.242,1.867,1.867,0,1,0-.957,3.594Z",
    transform: "translate(-109.249 -48.114)",
    fill: "#a4a1fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7123f3affbf18801a4ea3db851f3703c.svg";
export { ForwardRef as ReactComponent };